<div class="indicator">
  @for (i of steps(); track i) {
    <div
      class="indicator__step"
      [class.indicator__step--marked]="i <= currentStep()"
    ></div>
  }
</div>
